export const ROWS_COLOR = '#bbb'
export const ROW_FONT = 'normal 20px Helvetica,sans-serif'
export const ROW_FILL = '#96a2aa'

export const CIRCLE_RADIUS = 8



export enum Chart {
    WIDTH = 600,
    HEIGHT = 200,
    PADDING = 40,
    DPI_WIDTH = WIDTH * 2,
    DPI_HEIGHT = HEIGHT * 2,
    VIEW_HEIGHT = DPI_HEIGHT - PADDING * 2,
    VIEW_WIDTH = DPI_WIDTH,
    ROWS_COUNT = 5,
}

export enum Slider {
    HEIGHT = 40,
    DPI_HEIGHT = HEIGHT * 2,
    PADDING = -5,
}

export enum Animation {
    SPEED = 700,
}